import styled from "styled-components";

export const RelativeFlexFieldWrapper = styled.div`
  display: flex;
  position: relative;
`;
